// GB WhatsApp 最新稳定版信息（全站统一，月份自动取当前最新）
const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

function getCurrentMonthYear() {
  const now = new Date();
  return `${MONTH_NAMES[now.getMonth()]} ${now.getFullYear()}`;
}

const currentMonthYear = getCurrentMonthYear();
const currentYear = String(new Date().getFullYear());

export const APP_INFO = {
  version: 'v18.80',
  versionNum: '18.80',
  updateMonth: currentMonthYear,
  updateLabel: currentMonthYear,
  year: currentYear,
  apkSize: '~60 MB',
  androidReq: 'Android 5.0 and above',
  domain: 'gbwhatts.net',
  appName: 'GB_gbwhatts.net',
};

// 历史版本 APK 配置（每版独立下载标识）
export const OLD_VERSIONS = [
  {
    version: 'v18.80',
    versionNum: '18.80',
    size: '~60 MB',
    note: 'Current stable — recommended for most users',
    isLatest: true,
    appName: 'GB_gbwhatts.net',
  },
  {
    version: 'v18.70',
    versionNum: '18.70',
    size: '~58 MB',
    note: 'Previous stable — widely tested on most devices',
    appName: 'GB_gbwhatts_v1870',
    apkFallback: 'VUE_APP_GB_APK_1870',
  },
  {
    version: 'v18.65',
    versionNum: '18.65',
    size: '~57 MB',
    note: 'Older build — good for low-end devices',
    appName: 'GB_gbwhatts_v1865',
    apkFallback: 'VUE_APP_GB_APK_1865',
  },
  {
    version: 'v18.60',
    versionNum: '18.60',
    size: '~56 MB',
    note: 'Legacy version — use only if newer ones fail',
    appName: 'GB_gbwhatts_v1860',
    apkFallback: 'VUE_APP_GB_APK_1860',
  },
];
